<section class="images" [ngClass]="{'desktop-placeholder': images.length == 0, 'mobile-placeholder': imagesMobile.length == 0 || images.length == 0, 'quiz-placeholder': slideshow.quiz}">
    <!-- desktop -->
    <div class="left"
        [dndDropzone]="['image']" 
        [dndDisableIf]="!canEdit"
        (dndDrop)="drop($event, false)"
        [dndAllowExternal]="true">
        <!-- image placeholder -->
        <div 
            *ngIf="images.length == 0; else imageContainer" 
            class="image-placeholder faded" (click)="popImageDialog(null, true, false)">
            <div>
                <mat-icon>insert_photo</mat-icon>
                <span>{{ adsTab ? 'Add Ad Image' : 'Desktop' }}</span>
                <input type="file" #imageInput (change)="handleImageUpload($event.target.files, false)" multiple>
            </div>
        </div>
        <!-- dragover placeholder -->
        <div 
            class="dragover-placeholder">
                <mat-icon>insert_photo</mat-icon>
                <span>Drop Images Here</span>
        </div>
        <!-- images -->
        <ng-template #imageContainer>
            <div class="image" *ngFor="let image of images; let imgIndex = index; trackBy: utils.trackByIndex" [ngClass]="{thumb: imgIndex > 0}">
                <span>
                    <span class="notice" *ngIf="showNotice(image, imgIndex)">
                        <mat-icon *ngIf="!adsTab">priority_high</mat-icon>
                        <span class="panel faded">
                            <div class="inner mat-elevation-z2">
                                <p>The uploaded image is scaled up to meet the {{adsTab ? 'ad' : 'desktop'}} standard size. It may appear blury on some devices.</p>
                                <button *ngIf="!adsTab" (click)="imagesService.setSmallDesktop(image)">Do Not Scale Up</button>
                            </div>                            
                        </span>
                    </span>
                    <span class="actions" *ngIf="canEdit && !adsTab">
                        <mat-icon *ngIf="!slideshow.quiz && imgIndex == 0" title="Reset desktop size 800x533" (click)="imagesService.resetDesktopSize(image, false)">refresh</mat-icon>
                        <mat-icon title="Remove image" (click)="removeAttachment(images, imgIndex, false)">close</mat-icon>
                    </span>
                    <img 
                        loading="lazy"
                        (click)="popImageDialog(image, true, false)"
                        dndType="slideImage"
                        [dndDraggable]="i"
                        [dndEffectAllowed]="'move'"
                        [dndDisableIf]="!canEdit"
                        [attr.data-image-id]="image.id"
                        [attr.data-image-size]="adsTab ? 'ad' : slideshow.quiz ? 'quiz' : 'desktop'"
                        src="{{ getSrc(image, imgIndex, false, 'urlWithParams') }}"
                        height="{{ getSrc(images[0], 0, false, 'height') }}" />
                </span>
                <div *ngIf="imgIndex == 0" class="desc faded">{{ adsTab ? 'Ad' : slideshow.quiz ? 'Quiz' : 'Desktop' }} ({{ getDimensions(images[0], false) }})</div>                
            </div>
        </ng-template>
    </div>

    <!-- mobile -->
    <div class="right"
        *ngIf="slideshow.quiz !== true && !adsTab"
        [dndDropzone]="['image']" 
        [dndDisableIf]="!canEdit"
        (dndDrop)="drop($event, true)"
        [dndAllowExternal]="true">
        <span class="spinner" [ngClass]="{loading: loading}"><img src="/wp-content/themes/swarm/app/assets/images/loading.gif" /></span>
        <!-- image placeholder -->
        <ng-container *ngIf="imagesMobile.length == 0; else mobileTemplate">
            <div 
                *ngIf="showPlaceholder()" 
                class="image-placeholder faded" 
                (click)="popImageDialog(null, true, true)">
                <div>
                    <mat-icon>insert_photo</mat-icon>
                    <span>Mobile</span>
                    <input type="file" #imageInputMobile (change)="handleImageUpload($event.target.files, true)" multiple>
                </div>
            </div>
    
            
            <div class="image" 
                *ngIf="!showPlaceholder()">
                    <span>
                        <span class="actions" *ngIf="canEdit">
                            <mat-icon title="Reset mobile size" (click)="imagesService.resetMobileSize(images[0], false)">refresh</mat-icon>
                        </span>
                        <img 
                            loading="lazy"
                            dndType="slideImage"
                            [dndDraggable]="i"
                            [dndEffectAllowed]="'move'"
                            [dndDisableIf]="!canEdit"
                            [attr.data-image-id]="images[0].id"
                            [attr.data-image-size]="getSize(images[0])"
                            src="{{ getSrc(images[0], 0, true) }}"
                            height="{{ getSrc(images[0], 0, true, 'height') }}"
                            (click)="popImageDialog(images[0], true, true)">
                    </span>
                    <div class="desc faded">Mobile ({{ getDimensions(images[0], true) }})</div>
            </div>

        </ng-container>
        
        <!-- dragover placeholder -->
        <div 
            class="dragover-placeholder">
                <mat-icon>insert_photo</mat-icon>
                <span>Drop Images Here</span>
        </div>
        <!-- images -->
        <ng-template #mobileTemplate>
            <div class="image" *ngFor="let mobileImage of imagesMobile; let mobileIndex = index; trackBy: utils.trackByIndex" [ngClass]="{thumb: mobileIndex > 0}">
                <span>
                    <span class="actions" *ngIf="canEdit">
                        <mat-icon title="Reset mobile size" (click)="imagesService.resetMobileSize(mobileImage, false)">refresh</mat-icon>
                        <mat-icon title="Remove image" (click)="removeAttachment(imagesMobile, mobileIndex, true)">close</mat-icon>
                    </span>
                    <img 
                        loading="lazy"
                        (click)="popImageDialog(mobileImage, true, true)"
                        dndType="slideImage"
                        [dndDraggable]="i"
                        [dndEffectAllowed]="'move'"
                        [dndDisableIf]="!canEdit"
                        [attr.data-image-id]="mobileImage.id"
                        [attr.data-image-size]="getSize(mobileImage)"
                        src="{{ getSrc(mobileImage, mobileIndex, true) }}"
                        height="{{ getSrc(mobileImage, mobileIndex, true, 'height') }}" />
                </span>
                <div *ngIf="mobileIndex == 0" class="desc faded">Mobile ({{ getDimensions(imagesMobile[0], true) }})</div>
            </div>
        </ng-template>
    </div>
</section>